import React from 'react';
import { NavLink } from 'react-router-dom';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import Space from 'components/generic/Space.component';
import withSalonId from 'components/hoc/withSalonId.hoc';
import LINK from 'constants/link.const';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import linkTo from 'utils/links/linkTo.util';

import CN from './AlertAllStylistsOff.module.scss';

const AlertAllStylistsOff = ({ salonId, onClose }) => {
  const { t } = useTranslation();

  const calendarSettings = linkTo({
    pattern: LINK.settingsCalendar,
    params: { id: salonId },
    fault: '#',
  });

  return (
    <div data-bem="AlertAllStylistsOff" className={CN.component}>
      <Space>{t('scheduler.alertAllStylistsOff.description.part1')}</Space>

      <Space>{t('scheduler.alertAllStylistsOff.description.part2')}</Space>

      <Space>{t('scheduler.alertAllStylistsOff.description.part3')}</Space>

      <Space>
        <NavLink to={calendarSettings}>
          {t('scheduler.alertAllStylistsOff.linkText1')}
          {S.space}
          {S.arrowE}
          {S.space}
          {t('scheduler.alertAllStylistsOff.linkText2')}
        </NavLink>
      </Space>
      <div className={CN.closeButton}>
        <Button variant="empty" onClick={onClose}>
          <Icon variant="close" variantInvert />
        </Button>
      </div>
    </div>
  );
};

const AlertAllStylistsOffHoc = withSalonId(AlertAllStylistsOff);

// noinspection JSUnusedGlobalSymbols
export default AlertAllStylistsOffHoc;
